import { CookieClockIcon } from './CookieClockIcon';

/**
 * author: Colton Wiscombe
 * id 9DEBBFC6-6734-4D46-A7C0-3A11793C4708
 * name cookie-clock
 * version: 5.9.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cookie-clock.svg
 * tags
 * - Food / Drink 
 * - Date / Time 
 */
export const BiscuitClockIcon = CookieClockIcon;
export default BiscuitClockIcon